import { axiosPrivate } from "../api/axios";

const URL= '/grupos'
const URL_GRUPO= '/grupos/obtenergrupo'

const obtenerGrupos = async () => {
    try {
        const response = await axiosPrivate.get(URL,
            );
        //console.log(response);
        return response?.data;
    } catch (error) {
        //console.log(error.response);
        throw new Error(error);
    }
};

const crearGrupo = async (data) => {
    console.log(data);
    try {
        const response = await axiosPrivate.post(URL,
                data,
            );
        return response?.data;
    } catch (error) {
        throw new Error(error.response.data.error);
    }
};

const obtenerGrupo = async () => {
    try {
        const response = await axiosPrivate.get(URL_GRUPO,
            );
        //console.log(response);
        return response?.data;
    } catch (error) {
        //console.log(error.response);
        throw new Error(error.response.data.error);
    }
};


const deshacerGrupo = async ( _id) => {
    try {
        const response = await axiosPrivate.delete(`${URL}/${_id}`);
        return response?.data;
    } catch (error) {
        console.log(error);
        throw new Error(error.response.data.error);
    }
};

const GrupoService={
    obtenerGrupos,
    crearGrupo,
    obtenerGrupo,
    deshacerGrupo,
}

export default GrupoService;
